import { createContext, useContext } from 'react';

import { IUserProfileStore } from '../../core';

const userProfileContext = createContext<null | IUserProfileStore>(null);

export const useUserProfileStore = () => {
  const store = useContext(userProfileContext);

  if (!store)
    throw new Error('useUserProfileStore must be within UserProfileProvider');

  return store;
};

export const UserProfileProvider = userProfileContext.Provider;
